import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import slider1 from "@/Helper/images/services_sl1.png";
import Image from "next/image";
import ad1Tab from "@/Helper/images/problem_solving_with_BI_tools.png";
import ad2Tab from "@/Helper/images/beyond_charts_ storytelling_dashboards.png";
import ad3Tab from "@/Helper/images/Data_ Insight_action.png";
import ad4Tab from "@/Helper/images/empowering_with_self_servicebi.png";
import ad5Tab from "@/Helper/images/Right_data_with_Right_visual.png";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Problem Solving with BI Tools",
    "Beyond Charts: Storytelling Dashboards",
    "Data => Insight => Action",
    "Empowering with Self-Service BI",
    "Right⁵",
  ];

  const tabContent = [
    {
      heading: "Problem Solving with BI Tools",
      subheading: "We leverage advanced BI tools to tackle complex business challenges, identifying solutions that drive efficiency, growth, and competitive advantage.",
      image: ad1Tab,
    },
    {
      heading: "Beyond Charts: Storytelling Dashboards",
      subheading: " Our dashboards go beyond simple visuals, offering narrative-driven insights that bring data to life and make decision-making intuitive and impactful.",
      image: ad2Tab,
    },
    {
      heading: "Data => Insight => Action",
      subheading: "We turn raw data into meaningful insights, then translate those insights into actionable strategies, helping you move from information to informed action seamlessly.",
      image: ad3Tab,
    },
    {
      heading: "Empowering with Self-Service BI",
      subheading: "We equip your team with self-service BI capabilities, enabling everyone to access, analyze, and act on data independently, enhancing agility across the organization.",
      image: ad4Tab,
    },
    {
      heading: "Right⁵",
      subheading: "Right Data with Right visual to the Right Person at the Right Time for the Right Action! ",
      subheading_extra: " Our solutions ensure that critical insights reach the right people precisely when they're needed, empowering informed decisions that drive timely, effective actions.",
      image: ad5Tab,
    },
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}

          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${index === activeTab ? "active" : ""
            }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
            {content.subheading_extra && (
            <p className="subheading1">{content.subheading_extra}</p>
          )}
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
              <Image
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].heading}
                width={457}
                height={257}
                className="productbanner_imageslider"
                loading="eager"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
